import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step5 } from '../../../../shared/models/component-messages/simp_in/step5';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { TypeOuiNonInformComplementaire } from '../models/TypeOuiNonInformComplementaire';
@Component({
	selector: 'app-type-oui-non-inform-complementaire',
	templateUrl: './type-oui-non-inform-complementaire.component.html'
})
export class TypeOuiNonInformComplementaireComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeOuiNonInformComplementaire';
	@Input() parentForm: FormGroup;

	@Input() disabled: boolean;
	@Input() informComplementaire: TypeOuiNonInformComplementaire;

	public step5 = new Step5();


	constructor() {}

	public ngOnInit() {
		if (this.informComplementaire.oui) {
			this.informComplementaire.non = 'Oui';
		} else if(this.informComplementaire.oui === null && this.informComplementaire.non === null) {
			this.informComplementaire.non = null;
		}else{
      this.informComplementaire.non = 'Non';
    }
	}

	isInformComplementaireOui() {
		return this.parentForm.controls[this.getUid() + '_SepAtt_non'].value === 'Oui';
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
